module.exports = __webpack_public_path__ + "img/ParallelGateway.8199d675.svg";